import { handleOpenNewAccount } from 'common/navUtils';
import {
  ATBeaconButton,
  ATBeaconModal,
} from 'components/common/beacon/beaconRegistration';
import React, { useEffect } from 'react';
import { dispatchOverlayLoad } from 'utils/analyticsUtil';
import { CTAVariants } from '@trp-beacon-ui-kit/foundation/dist/_common/types/cta-variant';

interface ValidationModalProps {
  open: boolean;
  onClose: () => void;
  nasuLink: string;
  accountTypeId: number | null;
}

const ValidationModal: React.FC<ValidationModalProps> = ({
  open,
  onClose,
  nasuLink,
  accountTypeId,
}) => {
  useEffect(() => {
    if (open) {
      dispatchOverlayLoad('You don’t have this type of brokerage account with us');
    }
  }, [open]);
  return (
    <div className="beacon-on-light">
      <ATBeaconModal open={open} id="validation-modal" onBeaconEventClose={onClose}>
        <h2 className="b-typography-serif--headline--200 b-font-weight-bold">
          You don&apos;t have this type of brokerage account with us
        </h2>
        <div className="b-typography-sans-serif--body--200 b-font-weight-light">
          To complete your asset transfer, you can select a different account type or open
          a new brokerage account. Selecting &quot;Open New Brokerage Account&quot; takes
          you to a page that helps you set it up. Once your new account is open, you can
          return to the asset transfer page to start the transfer again.
        </div>
        <div slot="action-zone" className="action-zone-align-right">
          <ATBeaconButton
            slot="close-button-text"
            variant={CTAVariants.Tertiary}
            onBeaconEventClick={onClose}
          >
            Select a Different Account Type
          </ATBeaconButton>
          <ATBeaconButton
            slot="close-button-text"
            variant={CTAVariants.Primary}
            onBeaconEventClick={() => handleOpenNewAccount(nasuLink, accountTypeId)}
          >
            {'Open New Brokerage Account'}
          </ATBeaconButton>
        </div>
      </ATBeaconModal>
    </div>
  );
};

export default ValidationModal;
